import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var SmsItem = function (props) {
    var i18n = props.i18n, applicants = props.applicants, sms = props.sms;
    var reason = sms.reason, status = sms.status, recipient = sms.recipient;
    var _a = recipient || {}, phoneNumber = _a.phoneNumber, applicant = _a.applicant;
    var applicantReceiver = applicants[applicant];
    var text = "modules.timeline.sms.".concat(status === 'RECEIVED' ? 'textStatusReceived1' : 'textStatusPending');
    var description = getPropsByKeyPath(i18n, text).replace('$reason', reason);
    var applicantFullName = "".concat(applicantReceiver.firstName, " ").concat(applicantReceiver.lastName);
    return (_jsx(_Fragment, { children: _jsxs("p", { children: [description, " ", _jsx("b", { children: applicantFullName })] }) }));
};
